import { getReporter } from './reporter'

let networkTimer: ReturnType<typeof setInterval> | null = null
let networkChangeHandler: (() => void) | null = null

/**
 * 采集网络质量信息
 *
 * 使用 Network Information API 获取连接类型、带宽、延迟等，
 * 每次 flush 周期采集一次，网络切换时额外记录
 */
export function setupNetwork(): void {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') return

  const conn = navigator.connection
  if (!conn) return

  collectNetworkSnapshot()
  networkTimer = setInterval(collectNetworkSnapshot, 30000)

  networkChangeHandler = () => {
    collectNetworkSnapshot()
  }
  conn.addEventListener('change', networkChangeHandler)
}

/** 停止网络采集定时器并移除事件监听 */
export function destroyNetwork(): void {
  if (networkTimer) {
    clearInterval(networkTimer)
    networkTimer = null
  }
  if (networkChangeHandler) {
    const conn = navigator.connection
    conn?.removeEventListener('change', networkChangeHandler)
    networkChangeHandler = null
  }
}

/** 采集一次网络质量快照 */
function collectNetworkSnapshot(): void {
  const reporter = getReporter()
  if (!reporter) return

  const conn = navigator.connection
  if (!conn) return

  reporter.addNetwork({
    effectiveType: conn.effectiveType || 'unknown',
    downlink: conn.downlink || 0,
    rtt: conn.rtt || 0,
    saveData: conn.saveData || false,
    timestamp: Date.now(),
  })
}
